module.exports = require("@mui/base/SliderUnstyled");